import script from "./MetricStrip.vue?vue&type=script&setup=true&lang=js"
export * from "./MetricStrip.vue?vue&type=script&setup=true&lang=js"

import "./MetricStrip.vue?vue&type=style&index=0&id=0df1fc5a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0df1fc5a"]])

export default __exports__